module.exports = __webpack_public_path__ + "img/road-in-forest.e747cea2.jpg";